import wixData from 'wix-data';
import { session } from 'wix-storage';
// The code in this file will load on every page of your site

$w.onReady(function () {
    var countdownDiv = $w("#DeliveryCountdown");
    var countdownDiv2 = $w("#DeliveryCountdown2");
    var adaptativeTextBetiel = $w("#AdaptativeTextBetiel");
    var adaptativeTextKoala = $w("#AdaptativeTextKoala")
    var dayNames = ["domingo", "lunes", "martes", "miércoles", "jueves", "viernes", "sábado"];

    // Function to check if a date is a holiday
    function isHoliday(date, holidays) {
        var month = String(date.getMonth() + 1).padStart(2, '0');
        var day = String(date.getDate()).padStart(2, '0');
        var year = date.getFullYear();
        var dateString = `${month}/${day}/${year}`;
        return holidays.includes(dateString);
    }

    // Function to get the next workday (excluding Saturdays)
    function getNextWorkDay(date, holidays) {
        var nextWorkDay = new Date(date);
        do {
            nextWorkDay.setDate(nextWorkDay.getDate() + 1);
        } while (nextWorkDay.getDay() === 0 || nextWorkDay.getDay() === 6 || isHoliday(nextWorkDay, holidays)); // Exclude Sundays (0) and Saturdays (6)
        return nextWorkDay;
    }

    function updateCountdown() {
        var now = new Date();
        var betielCutTime = new Date();
        betielCutTime.setHours(15, 0, 0, 0);
        var koalaCutTime = new Date();
        koalaCutTime.setHours(12, 30, 0, 0);
        var betielAnnouncementText;
        var koalaAnnouncementText;
        var betielMapText;
        var koalaMapText;

        var holidays = [
            "01/01/2024","03/29/2024","03/30/2024",
            "05/01/2024","05/21/2024","06/20/2024","06/29/2024","07/16/2024",
            "08/15/2024","09/21/2024","10/12/2024","10/31/2024","11/01/2024",
            "12/24/2024","12/25/2024","12/31/2024","01/01/2025",
            "05/01/2025","05/21/2025","06/20/2025",
            "07/16/2025","08/15/2025","08/20/2025","09/18/2025","09/19/2025",
            "10/12/2025","10/31/2025","11/01/2025","11/16/2025",
            "12/08/2025","12/14/2025","12/25/2025","12/31/2025"
        ];
        var nextWorkDay = getNextWorkDay(now, holidays);

        if (now.getDay() === 0 || now.getDay() === 6 || isHoliday(now, holidays) || now > betielCutTime) { // If today is Sunday, Saturday, a holiday or after 3pm
            betielAnnouncementText = "Si eres de Gran Santiago*, ¡Compra hoy y recibe " + ((nextWorkDay.getDate() === now.getDate() + 1) ? "mañana" : "el " + dayNames[nextWorkDay.getDay()]) + "!";
            betielMapText = "Si estas en la zona morada, compra hoy y recibe tu pedido " + ((nextWorkDay.getDate() === now.getDate() + 1) ? "mañana" : "el " + dayNames[nextWorkDay.getDay()]) + "!";
            // betielDeliveryTime = (nextWorkDay.getDate() === now.getDate() + 1) ? "mañana" : "el " + dayNames[nextWorkDay.getDay()];
        } else {
            var diff = betielCutTime - now;
            var hours = Math.floor(diff / (1000 * 60 * 60));
            var minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
            var countdownTimer = hours > 0 ? "las próximas" + hours + " horas y " + minutes + " minutos" : "los próximos" + minutes + " minutos";
            betielAnnouncementText = "Si estás en Gran Santiago*, ¡Haz tu pedido en " + countdownTimer + " para recibirlo hoy!";
            betielMapText = "Si estas en la zona morada, compra en " + countdownTimer + " y recibe tu pedido hoy!";
            // betielDeliveryTime = "hoy";
        }

        if (now > koalaCutTime || now.getDay() === 0 || now.getDay() === 6 || isHoliday(now, holidays)) { // If today is Sunday, Saturday, a holiday or after 12:30pm
            koalaAnnouncementText = "Si eres de Gran Santiago*, ¡Compra hoy y recibe " + ((nextWorkDay.getDate() === now.getDate() + 1) ? "mañana" : "el " + dayNames[nextWorkDay.getDay()]) + "!";
            koalaMapText = "Si estas en la zona roja, compra hoy y recibe tu pedido " + ((nextWorkDay.getDate() === now.getDate() + 1) ? "mañana" : "el " + dayNames[nextWorkDay.getDay()]) + "!";
            // koalaDeliveryTime = (nextWorkDay.getDate() === now.getDate() + 1) ? "mañana" : "el " + dayNames[nextWorkDay.getDay()];
        } else {
            var diff = koalaCutTime - now;
            var hours = Math.floor(diff / (1000 * 60 * 60));
            var minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
            var countdownTimer = hours > 0 ? "las próximas" + hours + " horas y " + minutes + " minutos" : "los próximos" + minutes + " minutos";
            koalaAnnouncementText = "Si estás en Gran Santiago*, ¡Haz tu pedido en " + countdownTimer + " para recibirlo hoy!";
            koalaMapText = "Si estas en la zona roja, compra en " + countdownTimer + "y recibe tu pedido hoy!";
            // koalaDeliveryTime = "hoy";
        }

        updateDOMElements(betielAnnouncementText, betielMapText, koalaAnnouncementText, koalaMapText);
    }

    function updateDOMElements(betielAnnouncementText, betielMapText, koalaAnnouncementText, koalaMapText) {
        updateTextIfDifferent(countdownDiv, betielAnnouncementText);
        updateTextIfDifferent(countdownDiv2, betielAnnouncementText);
        updateTextIfDifferent(adaptativeTextBetiel, betielMapText);
        updateTextIfDifferent(adaptativeTextKoala, koalaMapText);
    }

    function updateTextIfDifferent(element, newText) {
        if (element.text !== newText) {
            element.text = newText;
        }
    }

    setInterval(updateCountdown, 60000);
    updateCountdown();

    // Check session storage for special announcement
    if (session.getItem("specialAnnouncementClosed") === "true") {
        $w('#special-announcement').hide();
    }

    // Check session storage for marketing announcement
    if (session.getItem("marketingAnnouncementClosed") === "true") {
        $w('#marketing-announcement').hide();
    }

});


$w('#special-announcement-close').onClick((event) => {
    $w('#special-announcement').hide();
    session.setItem("specialAnnouncementClosed", "true");
})


$w('#close-marketing-announcement').onClick((event) => {
    $w('#marketing-announcement').hide();
    session.setItem("marketingAnnouncementClosed", "true");
})